import React from 'react'

import { useTranslation } from 'react-i18next'

import CategoryList from '@components/music/CategoryList'
import PageLayout from '@layout/PageLayout'
import { SearchCategory } from '@services/SearchService'
import { useSession } from '@stores/globalData/globalData.store'

import type { SearchConfig } from '@services/SearchService'

const searchConfig: SearchConfig = Object.freeze({
  [SearchCategory.TITLE]: 16,
})
const CategoriesPage: React.FC = () => {
  const { t } = useTranslation()
  const session = useSession()

  return (
    <PageLayout
      title="Browse Music by Category | Noteflight"
      searchConfig={searchConfig}
      hideFooter={!session.isDefaultCommunity()}>
      <div className="flex flex-col p-4 md:p-8">
        <h1 className="text-h3 font-semibold">{t('content.browseByCategory')}</h1>
        <CategoryList />
      </div>
    </PageLayout>
  )
}

export default CategoriesPage
